import {UnsubscribeFavoriteUserError} from './UnsubscribeFavoriteUserError.js'

export default class UserFavoriteErrorsFactory {
  static unsubscribeFavoriteUserError = msg => new UnsubscribeFavoriteUserError(msg)
}
